import { useContext } from "react";

import { GetStreamContext } from "./GetStreamProvider";

const useGetStream = () => useContext(GetStreamContext);
export default useGetStream;
